import { render } from "./Prompts.vue?vue&type=template&id=0f3bcb88&scoped=true"
import script from "./Prompts.vue?vue&type=script&lang=js"
export * from "./Prompts.vue?vue&type=script&lang=js"

import "./Prompts.vue?vue&type=style&index=0&id=0f3bcb88&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3bcb88"]])

export default __exports__